<template>
  <div
    class="user-popover"
    ref="container"
  >
    <div class="user-info">
      <img
        ref="image"
        class="avatar"
        :src="account?.Image"
        :width="64"
        :height="64"
        @error="loadDefault()"
      >
      <div class="user-info-col">
        <div class="full-name">
          {{ account?.FullName }}
        </div>
        <div
          class="organization"
        >
          {{ account?.OrganizationName }}
        </div>
        <div
          class="profile label"
          @click="loginToMisaId(Index)"
        >
          {{ $t('Teacher.ViewProfile') }}
        </div>
      </div>
    </div>
    <div
      class="user-organization mt-3 pb-3 mx-2"
      v-if="organizationOptions?.length > 0"
    >
      <div class="label text-neutral-500 pl-2 mb-2">
        {{ $t('Document.ChangeSchool') }}
      </div>
      <div
        class="organization-item flex flex-row cursor-pointer rounded items-center"
        v-for="(organization, index) in organizationOptions"
        :key="index"
        @click="onClickOrganization(organization)"
      >
        <img
          class="icon"
          :src="require('@/assets/icons/svg/user_info/ic_School_20.svg')"
          :width="20"
          :height="20"
        >
        <div class="organization-name subtitle text-neutral-400">
          {{ organization.OrganizationName }}
        </div>
      </div>
    </div>
    <div class="user-option mx-2">
      <div
        class="option-item"
        v-for="(option, index) in options"
        :key="index"
        @click="option.onClick"
      >
        <img
          class="icon"
          :src="option?.icon"
          :width="20"
          :height="20"
        >
        <div>{{ option?.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseList from '@/views/base/base-list'
import { ActionGenLinkMisaId, App } from '@/common/constant'
import { getContextData, setContextData } from '@/utils/context-data'
import { mapActions, mapState } from 'vuex'
import { logout } from '@/views/pages/account/common/common-function'
import { redirectToApp } from '@/common/common-fn'

const ChangePassword = () => require('./change-password-popup')

const UPDATE_VISIBLE_VALUE = 'update:visible'

export default {
  extends: BaseList,

  emits: [UPDATE_VISIBLE_VALUE],

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  async mounted () {
    const me = this

    await me.getOrganization()
  },

  data () {
    return {
      changePasswordPopupName: 'ChangePasswordPopup',
      account: getContextData(),
      Index: ActionGenLinkMisaId.Index
    }
  },

  computed: {
    ...mapState('teacher', ['organizations']),

    /**
     * Tùy chọn thay đổi thông tin
     */
    options () {
      const me = this
      const list = [
        {
          iconName: 'ic_User_20',
          business: 'ProtectAccount',
          event: () => { me.loginToMisaId(ActionGenLinkMisaId.Security) }
        },
        {
          iconName: 'icon_password',
          business: 'ChangePassword',
          event: me.loginToMisaId.bind(me, ActionGenLinkMisaId.ChangePassword)
        },
        {
          iconName: 'icon_logout',
          business: 'Logout',
          event: me.onLogout
        }
      ]

      return list.map(option => {
        return {
          icon: require(`@/assets/icons/svg/user_info/${option.iconName}.svg`),
          text: me.$t(`User.${option.business}`),
          onClick: option.event
        }
      })
    },

    organizationOptions () {
      const me = this
      return me.organizations?.slice(1)
    }
  },

  methods: {
    ...mapActions('account', {
      getLinkMisaID: 'getLinkMisaID'
    }),

    ...mapActions('teacher', ['getOrganization', 'updateOrganization']),

    getContainer () {
      return this.$refs.container
    },

    async getOtherPopup (componentName) {
      let res = () => {}
      componentName === this.changePasswordPopupName && (res = ChangePassword)
      return await res()
    },

    hide () {
      this.$emit(UPDATE_VISIBLE_VALUE, false)
    },

    /**
     * @author PVThang
     * @description Đăng xuất
     */
    onLogout: logout,

    /**
     * @author PVThang
     * @description hiển thị popup đổi mật khẩu
     */
    showChangePassPopup () {
      const me = this

      me.hide()
      me.showDetail(me.changePasswordPopupName, {}, me.$enumeration.EditMode.Edit)
    },

    /**
     * @author PVThang
     * @description đăng nhập misaId
     */
    loginToMisaId (action) {
      const me = this

      me.hide()
      me.getLinkMisaID(action).then(res => {
        const url = res?.Data?.Data?.UrlCallback

        if (url) {
          window.open(url, '_blank')
        } else {
          me.$notify.showError({
            message: me.$t('User.HasErrorTryAgain')
          })
        }
      })
    },

    /**
     * Hàm xử lý sự kiện API không lấy được ảnh
     * Hiển thị ảnh đại diện mặc định
     */
    loadDefault () {
      this.$refs.image.src = require('@/assets/images/svg/avatar/default.svg')
    },

    /**
     * Xử lý sự kiện nhấn vào thay đổi trường
     */
    onClickOrganization (organization) {
      const me = this
      me.updateOrganization(organization).then((res) => {
        if (res.Data) {
          // Nếu cập nhật session thành công thì cập nhật Context data
          me.account.OrganizationID = organization.OrganizationID
          me.account.OrganizationName = organization.OrganizationName
          me.account.SchoolLevel = organization.SchoolLevel
          setContextData(me.account)
          // Redirect về màn DashBoard
          redirectToApp(App.Teacher)
        } else {
          // Nếu xảy ra lỗi thì show thông báo lỗi
          me.$notify.showError({
            message: me.$t('NotifyMessage.ErrorOccurred')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-popover {
  .user-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid $color-neutral-light-1;
    margin: 0 12px;
    img {
        margin: 12px 15px 24px 0;
        border-radius: $border-radius-circle;
        background-color: $color-neutral-light-1;
      }
    .user-info-col {
      flex-direction: column;
      margin-bottom: 18px;
      .full-name {
        @include title();
        color: $color-neutral-light-5;
        text-align: left;
        word-break: break-word;
      }
      .organization {
        width: 100%;
        align-items: center;
        text-align: left;
        word-break: break-word;
        color: $color-neutral-light-5;
      }
      .profile {
        color: $color-accent;
        cursor: pointer;
      }
    }
  }
  .user-option {
    padding-top: 6px;
    .option-item {
      @include subtitle();
      display: flex;
      height: 36px;
      align-items: center;
      cursor: pointer;
      border-radius: $border-radius-base;
      color: $color-neutral-light-4;
      margin: 6px 0;
      &:hover {
        background-color: rgba(138, 107, 246, 0.2);
        color: $color-accent;
      }
    }
  }
  .user-organization {
    border-bottom: 1px solid $color-neutral-light-1;
    .organization-item {
      height: 36px;
      .organization-name {
        text-align: left;
        word-break: break-word;
      }
    }
    .organization-item:hover {
      background-color: rgba(138, 107, 246, 0.2);
      color: $color-accent;
    }
  }
  .icon {
    margin: 0 8px;
  }
}
</style>
